import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";

const Field = ({
  value,
  onChange,
  options,
  unitValue,
  onChangeUnit,
  readOnly,
}) => {
  return (
    <Box display="flex" alignItems="center">
      <Box mr={1}>
        <FormControl>
          <TextField
            type="number"
            inputProps={{ inputMode: "decimal", readOnly }}
            value={value}
            onChange={onChange}
          />
        </FormControl>
      </Box>
      <FormControl>
        <Select native value={unitValue} onChange={onChangeUnit}>
          {options.map(({ name, value }) => (
            <option key={value} value={value}>
              {name}
            </option>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

Field.defaultProps = {
  readOnly: false,
};

export default Field;
